import { progressBarStyles, fillBarStyles } from '../SkillLevelScale.styles';
import { SkillLevelScaleProps, UseSkillLevelScaleReturn } from '../types';
import { SkeletonLoader } from '@/components/Loaders';

/**
 * Subcomponent responsible for rendering the progress bar of the SkillLevelScale,
 * including the fill and segment dividers.
 */
export const SkillLevelScaleProgressBar: React.FC<{
  currentLevel: UseSkillLevelScaleReturn['currentLevel'];
  fillWidth: number;
  getDividerDisplay: UseSkillLevelScaleReturn['getDividerDisplay'];
  gradientBackground: UseSkillLevelScaleReturn['gradientBackground'];
  isLoading: boolean;
  level: SkillLevelScaleProps['level'];
  size: SkillLevelScaleProps['size'];
  skillLevelsLength: number;
  useGradient: boolean;
}> = ({
  currentLevel,
  fillWidth,
  getDividerDisplay,
  gradientBackground,
  isLoading,
  level,
  size,
  skillLevelsLength,
  useGradient,
}) => {
  return (
    <div className={progressBarStyles({ size })}>
      {/* Fill bar */}
      {isLoading ? (
        <SkeletonLoader className="h-2.5 w-full" rounded="full" />
      ) : (
        <div
          className={fillBarStyles({ level: useGradient ? level : currentLevel || 'none' })}
          data-testid="skill-level-fill"
          data-fill={fillWidth}
          style={{ background: gradientBackground, width: `${fillWidth}%` }}
        />
      )}

      {/* Segment dividers */}
      {!isLoading &&
        Array(skillLevelsLength - 1)
          .fill(0)
          .map((_, index) => (
            <div
              key={index}
              className="absolute top-1/2 h-3 w-0.5 -translate-x-0.5 -translate-y-1/2 bg-neutral-white"
              data-testid={`skill-level-divider-${index}`}
              style={{
                left: `${((index + 1) / skillLevelsLength) * 100}%`,
                display: getDividerDisplay(index),
              }}
            />
          ))}
    </div>
  );
};
